import React from "react";
import ContactForm from "../ContactFrom/ContactForm";
import locationIcon from "../../images/icons/location.png";
import emailIcon from "../../images/icons/email.png";
import phoneIcon from "../../images/icons/phone.png";
import contactus1 from '../../images/contactus1.jpeg';

const Contactpage = () => {
    return (
        <>
        {/* SCROLL TARGET FOR BACK-TO-TOP */}
        <div id="scrool"></div>
        <section className="contact-wrapper">

            <div className="container">

                {/* ================= CONTACT INFO BLOCK ================= */}
                <div className="contact-block with-bg-image">

                    <div className="text-area">

                        <h2 className="contact-title">Contact Legacy Community Services</h2>

                        <p className="contact-subtext">
                            We are here to assist you with questions, management support, proposals, and community services.
                        </p>

                        <ul className="contact-list">

                            <li>
                                <img src={locationIcon} className="contact-icon" alt="Location"/>
                                <div>
                                    <strong>Florida Mailing Location</strong><br/>
                                    4142 Mariner Blvd. #255, Spring Hill, FL 34609
                                </div>
                            </li>
                            <li>
                                <img src={locationIcon} className="contact-icon" alt="Location"/>
                                <div>
                                    <strong>Virginia Mailing Location</strong><br/>
                                    525K East Market St. #597, Leesburg, VA 20176
                                </div>
                            </li>
                            <li>
                                <img src={locationIcon} className="contact-icon" alt="Location"/>
                                <div>
                                    <strong>Virginia Office Location</strong><br/>
                                    45945 Trefoil Lane #112, Sterling, VA 20166
                                </div>
                            </li>
                            <li>
                                <img src={emailIcon} className="contact-icon" alt="Email"/>
                                <div>
                                    <strong>Email</strong><br/>
                                    <a href="mailto:customerservice@legacycommunityservices.com">customerservice@legacycommunityservices.com</a>
                                </div>
                            </li>
                            <li>
                                <img src={phoneIcon} className="contact-icon" alt="Phone"/>
                                <div>
                                    <strong>Office Phone</strong><br/>
                                    <a href="tel:5713131004">571.313.1004</a>
                                </div>
                            </li>

                        </ul>
                    </div>

                    <img src={contactus1} alt="contactus1" />
                </div>

                {/* ================= CONTACT FORM ================= */}
                <div className="contact-form-block">
                    <h2 className="contact-form-title">Send Us a Message</h2>
                    <ContactForm />
                </div>

            </div>

        </section>
        </>
    );
};

export default Contactpage;
